module.exports = __webpack_public_path__ + "static/media/Hieu_Pham.d6145acb.png";